// Blocking

/**
 * @module actions-blocking
 * @desc (Actions) These actions manage the state associated with the Blocking component, including derived data from calculateBlocks functions.
 * @prop {function} addMarked - Adds a marked word by index to the state array when
 * clicked (includes offset)
 * @prop {function} removedMarked - Removes index of word from state array
 * @prop {function} toggleHover - Sets hover state to current index of argument (the word)
 * @prop {function} resetBlocks - (state) state associated with blocking
 * @prop {function} loadMarked - Loads previous marked data from the database (entries state)
 */

/**
* @function addMarked
* @param {object} index Comprised of two props: line number and word number of word
* @param {array} offsetLeft Array of words, spacing offset for words broken mid-line
* @desc (Action) Adds the word's location in relation to the poem when clicked by a user
* @returns {object} ADD_MARKED Returns updated markedWords and markedOffset
*/
function addMarked(index, offsetLeft){
  return (dispatch, getState) => {
    let { markedWords } = getState().blocking;
    markedWords = Object.assign({}, markedWords);

    //Check if line index already created
    if(markedWords[index.line]){
      //If word already marked, exit
      const exists = markedWords[index.line].indexOf(index.word);
      if(exists !== -1)
        return

      //If line index already exists, push to the line's array
      markedWords[index.line].push(index.word)
    }else {
      //If line index doesn't exist, create and assign word
      markedWords[index.line] = [index.word];
    }

    //This provides spacing offset for words broken mid-line
    const markedOffset = {index, offsetLeft};

    dispatch ({ type: 'ADD_MARKED', markedWords: markedWords, markedOffset: markedOffset});
  }
}

/**
* @function removeMarked
* @param {object} index Comprised of two props: line number and word number of word
* @desc (Action) Removes word via index from markedWords object
* @returns {object} REMOVE_MARKED markedWords Returns updated markedWords and markedOffset
*/
function removeMarked(index){
  return (dispatch, getState) => {
    let { markedWords } = getState().blocking;
    markedWords = Object.assign({}, markedWords);

    //Check if exists, if not return
    const exists = markedWords[index.line].indexOf(index.word);

    if(exists < 0)
      return

    //Remove if exists
    markedWords[index.line].splice(exists, 1);

    //Delete line prop if no other words are marked
    if(markedWords[index.line].length < 1)
      delete markedWords[index.line];

    dispatch ({ type: 'REMOVE_MARKED', markedWords: markedWords });
  }
}

/**
* @function toggleHover
* @param {object} index Comprised of two props: line number and word number of word
* @desc (Action) Removes word via index from markedWords object
* @returns {object} REMOVE_MARKED markedWords Returns updated markedWords and markedOffset
*/
function toggleHover(index) {
  //If no arg passed there is no hover
  if(!index)
    index = {word: null, line: null}
  return { type: 'TOGGLE_HOVER', index: index }
}

/**
* @function resetBlocks
* @desc (Action) Resets the markedWords state of blocks
* @returns RESET_BLOCKS returns only an action type (handled in reducer)
*/
function resetBlocks() {
  return {type: 'RESET_BLOCKS'}
}

/**
* @function loadMarked
* @param {object} blocks the state object of blocks
* @desc (Action) Loads the markedWords (marked) from entries (user data)
* @returns {object} LOAD_MARKED returns markedWords and markedOffset
*/
function loadMarked(blocks){
  return {type: 'LOAD_MARKED', markedWords: blocks.marked, markedOffset: blocks.offsets}
}

export { addMarked, removeMarked, toggleHover, resetBlocks, loadMarked };



// WEBPACK FOOTER //
// ./src/actions/blocking.js